export enum IconSize {
  APP_FONT_SIZE = 'AppFontSize',
  PARENT_FONT_SIZE = 'ParentFontSize',
  SMALL = 'Small',
  NORMAL = 'Normal',
  MEDIUM = 'Medium',
  LARGE = 'Large',
  SUPER_GIANT = 'SuperGiant',
}
